import {
  Search, Sparkles, MousePointerClick, Repeat, Scale, Heart, ShieldCheck, Briefcase,
  FileText, MapPin, HeartPulse, FlaskConical, Users, Layers, Gauge, Cog, Home,
  Lightbulb, Hammer, Radar, Store, ShoppingCart, PenTool, MonitorSmartphone,
  GraduationCap, Trophy, Telescope, Workflow, BarChart3, Check, TrendingUp, Building2, Target
} from "lucide-react";

/* Maps the icon names used in the Python page_builder to lucide-react components,
   so the React preview and the deployed WP pages stay visually in sync. */
export const ICONS = {
  "search": Search,
  "sparkles": Sparkles,
  "mouse-pointer-click": MousePointerClick,
  "repeat": Repeat,
  "scale": Scale,
  "heart": Heart,
  "shield-check": ShieldCheck,
  "briefcase": Briefcase,
  "file-text": FileText,
  "map-pin": MapPin,
  "heart-pulse": HeartPulse,
  "flask-conical": FlaskConical,
  "users": Users,
  "layers": Layers,
  "gauge": Gauge,
  "cog": Cog,
  "house": Home,
  "lightbulb": Lightbulb,
  "hammer": Hammer,
  "radar": Radar,
  "store": Store,
  "shopping-cart": ShoppingCart,
  "pen-tool": PenTool,
  "monitor-smartphone": MonitorSmartphone,
  "graduation-cap": GraduationCap,
  "trophy": Trophy,
  "telescope": Telescope,
  "workflow": Workflow,
  "bar-chart-3": BarChart3,
  "check": Check,
  "trending-up": TrendingUp,
  "building-2": Building2,
  "target": Target,
};

export const iconFor = (name) => ICONS[name] || Sparkles;
